// Shared language constants + detection, used by both the router (to redirect
// unprefixed/invalid URLs) and LanguageContext (to pick the active language).

export const SUPPORTED = ["ar", "fr", "en"];
export const FALLBACK_LANG = "fr";
export const STORAGE_KEY = "preferredLanguage";

// First visit / no path lang: localStorage -> browser -> French.
export function detectInitialLang() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (SUPPORTED.includes(stored)) return stored;
  } catch (e) {
    // localStorage unavailable (private mode) — fall through.
  }
  const nav = (navigator.language || "").slice(0, 2).toLowerCase();
  if (SUPPORTED.includes(nav)) return nav;
  return FALLBACK_LANG;
}

export function isSupported(lang) {
  return SUPPORTED.includes(lang);
}

// Prefix an app path with the language segment: ("fr", "/blog") -> "/fr/blog".
export function localizedPath(lang, path = "/") {
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `/${lang}${clean === "/" ? "" : clean}`;
}
